import $http from '@nuxt-common/util/app/utils/http';

export default function () {
  $http.interceptors.request.use(
    async (request) => {
      // Adding PersistentLoginUtil to pass to the header in every API call

      const { PersistentLoginUtil } = await import('@nuxt-common/util/app/utils/persistentLogin');
      request.headers = {
        ...request.headers,
        ...PersistentLoginUtil.getDeviceFingerPrintHeaders(),
      };
      return request;
    },
    (error) => Promise.reject(error),
  );
}
